import "./error.scss";

import React from 'react';
import ErrorIcon from "assets/images/svg/missing_red.svg"

function ErrorMessage({message = "Server Error"}) {
    return (
        <div className='error-message'>
            <img src={ErrorIcon} alt="error-icon"/>
            <p>{message}</p>
        </div>
    );
}

export default ErrorMessage;